import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue-demi";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { PermissionsByRoute } from "./codes/types/PermissionsByRoute";
import { VUEX_ACTIONS } from "./codes/util/constants";
import router from "./router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();

const checkPermissions = function() {
  if (route && route.name) {
    const permissions = PermissionsByRoute[route.name.toString()];
    if (permissions && permissions.length > 0 && !store.getters.hasPermissions(permissions)) {
      router.replace({ name: 'unauthorized' });
    }
  }
}

onMounted(() => {
  store.subscribeAction({
    after: (action) => {
      if (action.type === VUEX_ACTIONS.setUserInfo) {
        checkPermissions();
      }
    }
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})